<template>
  <v-bottom-navigation app width="100vw" class="bottom-bar spotlight" flat>
    <NavTileComponent v-for="item in items" :key="item.route.name" :route="item.route" :title="item.title" :icon="item.icon" :count="item.count"
      asButton>
    </NavTileComponent>
  </v-bottom-navigation>
</template>


<script>
import AuthStoreMixin from "@/helpers/mixins/AuthStoreMixin";
import NavTileComponent from "@/components/NavTileComponent.vue";

export default {
  name: "BottomBar",
  props: { items: Array },
  mixins: [AuthStoreMixin],
  components: {
    NavTileComponent,
  },

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {
    shoppingCartCount() {
      return this.shoppingCartItemCount;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>



</style>